function Header() {
  return (
    <div className="logo">
      <img src="/img/brain.png" alt="Logo" width={75} height={75} />
      <h2>SQUIZ</h2>
    </div>
  );
}

export default Header;